exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: relative;\n  display: block;\n  border-color: #ddd;\n  border-style: dashed;\n  border-width: 1px;\n  margin-top: 1rem;\n  margin-right: 1rem;\n  margin-bottom: 1rem;\n  margin-left: 1rem; }\n  :host .file-drop {\n    padding-top: 1rem;\n    padding-right: 1rem;\n    padding-bottom: 1rem;\n    padding-left: 1rem;\n    transition: 0.2s; }\n    :host .file-drop.drag-active {\n      transition: 0.2s;\n      background: #4a90e2;\n      color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-form/components/input-file/input-file.component.scss
// module id = ../../../../../src/app/modules/ui-form/components/input-file/input-file.component.scss
// module chunks = main